import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";

import { Checkbox } from "@/components/ui/checkbox";
import { Field, FieldError, FieldLabel } from "@/components/ui/field";

const FormCheckbox = ({ name, label, required, disabled, id, ...rest }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const inputId = id ?? name;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          <div className="tw:flex tw:items-center tw:gap-2">
            <Checkbox
              {...rest}
              id={inputId}
              disabled={disabled}
              aria-required={required || undefined}
              aria-invalid={error ? true : undefined}
              checked={!!field.value}
              onBlur={field.onBlur}
              onCheckedChange={checked => field.onChange(!!checked)}
            />
            {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
          </div>
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default FormCheckbox;
